import type { ReactNode } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useMediaQuery, useTheme } from '@mui/material';

import { useDialogAutoFocus } from '../../hooks/useDialogAutoFocus.hook';

interface Props {
  readonly content: ReactNode;
  readonly isOpen: boolean;
  readonly isValid?: boolean;
  readonly onCancel: () => void;
  readonly onValidate: () => void;
  readonly title: string;
}

export const ActionDialog = ({
  content,
  isOpen,
  isValid,
  onCancel: handleCancel,
  onValidate: handleValidate,
  title,
}: Readonly<Props>) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const dialogAutoFocusSlotProps = useDialogAutoFocus();

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      onClose={handleCancel}
      open={isOpen}
      slotProps={dialogAutoFocusSlotProps}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button
          data-dialog-autofocus
          disabled={isValid === false}
          onClick={handleValidate}
          size="large"
          variant="contained"
        >
          Valider
        </Button>
        <Button onClick={handleCancel} size="large" variant="outlined">
          Annuler
        </Button>
      </DialogActions>
    </Dialog>
  );
};
